import { useRef as f, useEffect as v } from "react";
const E = "Escape", h = (r, c, i, s, a) => {
  const y = (e) => {
    i && (e.preventDefault(), c());
  }, l = f(null);
  v(() => {
    const e = (u) => {
      var m;
      ((m = l.current) == null ? void 0 : m.contains(document.activeElement)) && i && u.key === E && c();
    }, t = () => {
      document.addEventListener("keydown", e);
    }, d = () => {
      document.removeEventListener("keydown", e);
    };
    return r ? t() : d(), d;
  }, [
    r,
    i,
    c
  ]);
  const n = f({
    overflow: "",
    ariaHidden: !1
  }), o = f(!1);
  return v(() => {
    const e = document.getElementById(s);
    !o.current && r && (n.current.overflow = document.body.style.overflow, n.current.ariaHidden = (e == null ? void 0 : e.getAttribute("aria-hidden")) === "true");
    const t = a !== void 0 && document.getElementById(a), d = () => {
      document.body.style.overflow = "hidden", e && e.setAttribute("aria-hidden", "true"), t && t.setAttribute("aria-hidden", "true"), o.current = !0;
    }, u = () => {
      o.current && (document.body.style.overflow = n.current.overflow, e && !n.current.ariaHidden && e.removeAttribute("aria-hidden"), t && t.removeAttribute("aria-hidden"), o.current = !1);
    };
    return r ? d() : u(), u;
  }, [
    r,
    s,
    a
  ]), {
    modalRef: l,
    handleClose: y
  };
};
export {
  h as default
};
